<style scoped>
.actions-dropdown {
    position: relative;
    display: inline-block;
}

.actions-button {
    font-weight: 500;
    border: none;
    background: linear-gradient(90deg, #1e73be, #00a1cf);
    color: white;
    font-size: 13px;
    padding: 9px 15px;
    border-radius: 4px;
    text-transform: uppercase;
    display: flex;
    align-items: center;
    cursor: pointer;
    transition: 0.15s ease;
    gap: 8px;
}

.actions-button:hover {
    opacity: 0.9;
}

.actions-button .fa-icon {
    width: 13px;
    height: 13px;
    color: white;
}

.dropdown-menu {
    position: absolute;
    right: 0;
    top: calc(100% + 5px);
    background-color: white;
    border-radius: 4px;
    box-shadow: 0px 4px 15px rgba(0, 10, 20, 0.15);
    min-width: 220px;
    z-index: 1000;
    overflow: hidden;
}

.dropdown-item {
    padding: 12px 20px;
    cursor: pointer;
    transition: background-color 0.2s;
    display: flex;
    align-items: center;
    gap: 10px;
    color: rgb(30, 40, 50);
    font-size: 13px;
    font-weight: 500;
    border-bottom: 1px solid rgb(240, 243, 246);
}

.dropdown-item:last-child {
    border-bottom: none;
}

.dropdown-item:hover {
    background-color: rgb(248, 250, 252);
}

.dropdown-item .fa-icon {
    width: 14px;
    height: 14px;
    color: rgb(100, 110, 120);
}
</style>

<template>
    <div class="actions-dropdown">
        <button 
            class="actions-button" 
            @click="toggleDropdown"
            @blur="closeDropdown"
        >
            <font-awesome-icon :icon="['fas', 'bars']" />
            <span>Actions</span>
            <font-awesome-icon :icon="['fas', isOpen ? 'chevron-up' : 'chevron-down']" />
        </button>
        
        <div v-if="isOpen" class="dropdown-menu" @mousedown.prevent>
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ActionsDropdown',
    data() {
        return {
            isOpen: false
        };
    },
    methods: {
        toggleDropdown() {
            this.isOpen = !this.isOpen;
        },
        closeDropdown() {
            setTimeout(() => {
                this.isOpen = false;
            }, 200);
        }
    }
};
</script>
